<template>
    <div class="page-container">
        <div class="page-content">
            <div class="left-side-container">
                <div class="page-header">
                    <h1>{{ $t('Счета') }}</h1>
                </div>

                <div class="accounts-container">
                    <AccountItem @open="openAccount(account)" :account="account" v-for="account in accounts" :key="account.id" />
                </div>
            </div>

            <div class="right-side-container sticky">
                <RightSideUserControls />

                <AccountForm />
            </div>
        </div>
        
        <MobilePlusBtn type="new-account" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AccountItem from "@/new/components/Accounts/AccountItem.vue";
import AccountForm from "@/new/components/Accounts/AccountForm.vue";
import RightSideUserControls from "@/new/components/RightSideUserControls.vue";
import MobilePlusBtn from "@/new/components/MobilePlusBtn.vue";
import { EventBus } from '../../../event-bus';

export default {
    name: "Accounts",

    components: {
        RightSideUserControls,
        MobilePlusBtn,
        AccountItem,
        AccountForm
    },

    data: function() {
        return {
            //
        };
    },

    mounted() {
        this.loadAccounts();
    },

    computed: {
        ...mapGetters(['accounts', 'isAccountsLoaded']),
    },

    methods: {
        ...mapActions(['loadAccounts']),

        openAccount(account) {
            EventBus.$emit('open-side-form', 'edit-account', {account: account});
        },
    }
}
</script>

<style scoped lang="scss">
.right-side-container {
    @media (max-width: 768px) {
        display: none;
    }
}


.accounts-container {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    @media (max-width: 768px) {
        padding: 16px;
    }
}
</style>